// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"315":"about-app","354":"samples-preview","825":"about-sonic-pi"}[chunkId] + "." + {"315":"723b7dfb","354":"69fa43c7","825":"e9ab299e"}[chunkId] + ".css";
};